<template>
  <v-card>
    <v-row v-if="showRemoveButton" class="pr-4 mt-n5">
      <v-spacer />
      <v-btn small icon @click="removeBlob(blob.blobName)"><v-icon>close</v-icon></v-btn>
    </v-row>
    
    <v-list-item>
      <v-list-item-avatar v-if="getMediaType(blob.contentType) === 'image'" size="60" tile>
        <img v-if="!blob.isLibraryItem"  v-img-orientation-changer :src="blob.previewUrl" class="image object-fit_contain">
        <img v-else :src="blob.previewUrl">
      </v-list-item-avatar>
      <v-list-item-avatar v-else size="60" tile>
        <img :src="getThumbnail(blob)" class="image object-fit_contain">
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-subtitle>{{ getExpression('Label', 'Name') }}: {{ getName(blob) }}</v-list-item-subtitle>
        <v-list-item-subtitle>{{ getExpression('Label', 'Type') }}: {{ blob.contentType }}</v-list-item-subtitle>
        <v-list-item-subtitle>{{ getExpression('Label', 'Size') }}: {{ getSize(blob) }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: "MediaPropertiesForm",
  props: {
    blob: {
      type: Object,
      default: null
    },
    showRemoveButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      itemName: null
    }
  },
  methods: {
    getThumbnail (item) {
      return item.previewUrl
    },

    getSize (item) {
      if (item === undefined) return null
      return item.isLibraryItem ?? true
        ? this.getFormattedSize(item.size)
        : item.size
    },

    removeBlob (blobName) {
      this.$emit('remove', blobName)
    },

    getName (item) {
      if (this.itemName === null) {
        this.itemName = item.title
      }
      return this.itemName
    }
  }
}
</script>

<style>
.image {
  width: 60px;
  height: 60px;
}

.object-fit_contain {
  object-fit: contain;
  border: dotted 1px #bbb;
  margin-top: 3px;
}
</style>